import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function createLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function signup(payload) {
  const { data } = await api.post("/signup", payload);
  return data;
}

export async function fetchTiers() {
  const { data } = await api.get("/tiers");
  return data;
}

export async function createCheckoutSession({ tier, cycle = "monthly", email }) {
  const { data } = await api.post("/checkout/session", {
    tier,
    cycle,
    email,
    origin: window.location.origin,
  });
  return data;
}

export async function getCheckoutStatus(sessionId) {
  const { data } = await api.get(`/checkout/status/${sessionId}`);
  return data;
}
